import { type ApiResponseState, ResponseStatusCodes, generateEventBusName } from '@codestreet/api'
import { eventBus } from '@codestreet/event-bus'

export function emitError<R>(responseState: ApiResponseState<R>, path: string): void {
  if (responseState.isError && responseState.responseStatus) {
    const eventBusName = generateEventBusName(String(responseState.responseStatus))
    eventBus.emit(eventBusName, {
      path,
    })
  }

  if (!responseState.error) return

  const isBannedOrRemoved =
    responseState.error.code === ResponseStatusCodes.BANNED ||
    responseState.error.code === ResponseStatusCodes.REMOVED

  if (!isBannedOrRemoved) return

  const eventBusName = generateEventBusName(String(responseState.error.code))
  eventBus.emit(eventBusName, responseState.error.message)
}
